module.exports = __webpack_public_path__ + "img/planting_05@2x.88f3fd5.jpg";